import Vue from "vue";
import Vuex from "vuex";
import auth from "./modules/auth.store";
import core from "./modules/core.store";
import records from "./modules/records.store";
import courses from "./modules/courses.store";
import exams from "./modules/exams.store";
import questions from "./modules/questions.store";
import cache from "@/store/cache.plugin";
Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [cache],
  modules: {
    auth,
    core,
    records,
    courses,
    exams,
    questions
  }
});
